import React, { useEffect, useState } from 'react'
import { useInvoices, InvoicesRequest } from '../../../services/api/invoices'
import { defaultPagination } from '../../../services/api/client/types'
import { View } from './View'
import { useQuery } from '../../../utils/hooks/query'
import { useHistory } from 'react-router-dom'
import { InvoiceListItem } from '../../../lib/types/Invoice'

export const Container: React.FunctionComponent = () => {
  const query = useQuery()
  const history = useHistory()

  const [companyId, setCompanyId] = useState<string | undefined>(
    query.get('company') as string
  )
  const [invoices, setInvoices] = useState<InvoiceListItem[]>([])
  const [getInvoices, { isLoading, response }] = useInvoices()

  const [request, setRequest] = useState<InvoicesRequest>({
    companyId: companyId,
    createdAtFrom: undefined,
    createdAtTo: undefined,
    ...defaultPagination,
  })

  useEffect(() => {
    getInvoices(request).then(({ data: invoices }) => {
      setInvoices(invoices)
    })
  }, [getInvoices, request])

  const onSubmit = (form: InvoicesRequest) => {
    if (request.companyId !== companyId) {
      companyId ? query.set('company', companyId) : query.delete('company')
      history.push({ search: '?' + query.toString() })
    }

    setRequest({
      ...request,
      ...form,
      companyId: companyId,
      ...defaultPagination,
    })
  }

  const onInvoiceUpdate = (updatedInvoice: InvoiceListItem): void => {
    const updatedInvoices: InvoiceListItem[] = invoices.map((invoice) => {
      return invoice.id === updatedInvoice.id ? updatedInvoice : invoice
    })
    setInvoices(updatedInvoices)
  }

  const onCompanyChange = (companyId?: string): void => {
    setCompanyId(companyId)
  }

  const onPaginationChange = (page: number, perPage?: number) => {
    const newRequest = Object.assign({}, request, {
      page: page,
      perPage: perPage || defaultPagination.perPage,
    })

    setRequest(newRequest)
  }

  return (
    <View
      invoices={isLoading ? [] : invoices}
      meta={response?.meta}
      isLoading={isLoading}
      initialValues={request}
      onSubmit={onSubmit}
      companyId={companyId}
      onInvoiceUpdate={onInvoiceUpdate}
      onCompanyChange={onCompanyChange}
      onPaginationChange={onPaginationChange}
    />
  )
}
